export const UnitData = [
    {
        id: 1,
        name: "pcs"
    },
    {
        id: 2,
        name: "carats"
    },
    {
        id: 3,
        name: "gm"
    },
    {
        id: 4,
        name: "kg"
    },
    {
        id: 5,
        name: "set"
    },
];